module.exports = __webpack_public_path__ + "img/1-2.e9327fa3.png";